import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';


/*
*
*  License Page
*
*/
@Component({
  selector: 'license',
  templateUrl: 'license.html'
})
export class License {

    public item : any = {};

    constructor(
        private params: NavParams,
        private navCtrl: NavController
    ) {
        this.item  = this.params.data;
    }

    pop() {
    	this.navCtrl.pop()
    }

}



// WEBPACK FOOTER //
// ./src/pages/license/license.ts